export default __webpack_public_path__ + "static/oasis-24dbe9ae5e55308a413c4e37db782a04.jpg";